import { IndustriesSection } from "../components/IndustriesSection";
import { CTABand } from "../components/CTABand";
import { useSEO } from "../lib/useSEO";

export default function IndustriesPage() {
  useSEO({
    title: "Industries We Secure — Construction, Substations, Industrial, Events",
    description: "USI Security protects UK construction sites, electrical substations, industrial units, transport depots, events and utilities with SIA-licensed officers, CCTV towers and K9 patrols.",
    keywords: "construction site security UK, substation security, industrial site security, event security UK, transport depot security, utilities security, warehouse security UK, plant security",
    path: "/industries",
  });
  return (
    <div data-testid="industries-page" className="pt-24">
      <section className="relative py-20 lg:py-28 border-b border-white/10">
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-cyan-400 mb-4">
            ◆ Industries
          </p>
          <h1 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.02] tracking-tighter max-w-4xl">
            Tailored protection for<br />
            <span className="text-gradient-cyan">the sectors that matter.</span>
          </h1>
          <p className="mt-6 text-lg text-slate-400 max-w-2xl leading-relaxed">
            Every site brings unique pressures. Our consultants design solutions around the specific operational, regulatory and insurance realities of your industry.
          </p>
        </div>
      </section>

      <IndustriesSection />
      <CTABand />
    </div>
  );
}
